import { render, staticRenderFns } from "./bodyCell.vue?vue&type=template&id=1706e716&scoped=true&"
import script from "./bodyCell.vue?vue&type=script&lang=js&"
export * from "./bodyCell.vue?vue&type=script&lang=js&"
import style0 from "./bodyCell.vue?vue&type=style&index=0&id=1706e716&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1706e716",
  null
  
)

export default component.exports